import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import PropTypes from 'prop-types';
import styleable from 'react-styleable';
import { show, hide } from './busy-indicator-actions';
import css from './busy-indicator.scss';
import addInterceptors from '../../helpers/busy-indicator-interceptor';

@styleable(css)
class BusyIndicator extends Component {
    static propTypes= {
        busyIndicatorState: PropTypes.object,
        hide: PropTypes.func
    };
    componentWillMount() {
        this.props.hide();
    }
    render() {
        const { callCounter } = this.props.busyIndicatorState;
        if (callCounter < 1) {
            return null;
        }
        return (
            <div className={css['busy-indicator']} />
        );
    }
}

function mapStateToProps(state) {
    return {
        busyIndicatorState: state.busyIndicatorReducer
    };
}

function mapDispatchToProps(dispatch) {
    addInterceptors(
        dispatch,
        show,
        hide);
    return bindActionCreators({
        show,
        hide
    }, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(BusyIndicator);



// WEBPACK FOOTER //
// ./components/busy-indicator/busy-indicator.js